export const companiesFormData = {
  name: '',
  id: '',
  address1: '',
  address2: '',
  contactNumber: '',
  isActive: '0',
  stateProv: '',
  city: '',
  postalCode: '',
  state: '',
  phone: ''
};

export const companiesEnabledOptions = [
  { value: '1', label: 'Active' },
  { value: '0', label: 'Inactive' }
];
